import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { EmailInboxComponent } from '../../pages/email-inbox/email-inbox.component';
import { CallHistoryComponent } from '../../pages/voip/call-history/call-history.component';
import { VoipDashboardComponent } from '../../pages/voip/voip-dashboard/voip-dashboard.component';

export const communicationRoutes: Routes = [
  {
    path: 'mail/inbox',
    component: EmailInboxComponent,
    canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: {
      title: 'titles-menu-pages.email_inbox',
      role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'],
      account_type: ['broker', 'supplier'],
    },
  },
  {
    path: 'voip/calls',
    component: CallHistoryComponent,
    canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: {
      title: 'titles-menu-pages.call_history',
      role: ['Admin', 'Supervisor', 'Agent', 'Sales'],
      account_type: ['broker', 'supplier'],
    },
  },
  {
    path: 'voip/dashboard',
    component: VoipDashboardComponent,
    canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: {
      title: 'titles-menu-pages.voip_dashboard',
      role: ['Admin', 'Supervisor', 'Agent', 'Sales'],
      account_type: ['broker', 'supplier'],
    },
  },
];

export function getFilteredCommunicationRoutes(accountType: string, role: string): Routes {
  return communicationRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
